// extracted by mini-css-extract-plugin
export var imgPartenaire = "mentions-legales-module--img-partenaire--75bb6";
export var mentionsContainer = "mentions-legales-module--mentions-container--d2dec";
export var mentionsSubTitle = "mentions-legales-module--mentions-sub-title--132a1";
export var mentionsTitle = "mentions-legales-module--mentions-title--16159";
export var orderedItem = "mentions-legales-module--ordered-item--da172";